import {
    REGISTER_WIZARD_ROUTES,
    REGISTER_TYPES,
    MY_PERMISSIONS,
    REGISTERS_PERMISSIONS
} from '@/constants'
import { myPermissionsGuard } from '@src/router/guards'

export default {
    name: REGISTER_WIZARD_ROUTES.INTERNAL_AUDIT_PERFORMING.INDEX.name,
    component: () =>
        import('@/containers/RegisterWizard/InternalAudits/Performing'),
    path: 'internal-audits/:auditId/performing',
    props: true,
    redirect: to => ({
        name: REGISTER_WIZARD_ROUTES.INTERNAL_AUDIT_PERFORMING.WIZARD.name,
        params: { ...to.params }
    }),
    meta: {
        requiresAuth: true,
        register: REGISTER_TYPES.INTERNAL_AUDITS
    },
    children: [
        {
            path: 'wizard',
            name: REGISTER_WIZARD_ROUTES.INTERNAL_AUDIT_PERFORMING.WIZARD.name,
            component: () =>
                import(
                    '@/components/registers/internal-audits/performing/WizardTab'
                ),
            props: true,
            meta: {
                pageTitle: 'REGISTERS.INTERNAL_AUDITS.TITLE',
                withScaling: true,
                requiresAuth: true,
                register: REGISTER_TYPES.INTERNAL_AUDITS,
                shouldSkipRouteInHistory: true,
                guards: [myPermissionsGuard],
                permissions: [
                    MY_PERMISSIONS.INTERNAL_AUDIT_ACCESS,
                    REGISTERS_PERMISSIONS.AUDIT_REGISTER
                ]
            }
        },
        {
            path: 'properties',
            name:
                REGISTER_WIZARD_ROUTES.INTERNAL_AUDIT_PERFORMING.PROPERTIES
                    .name,
            component: () => import('@/components/registers/PropertiesTab'),
            props: true,
            meta: {
                pageTitle: 'REGISTERS.INTERNAL_AUDITS.TITLE',
                withScaling: true,
                requiresAuth: true,
                register: REGISTER_TYPES.INTERNAL_AUDITS,
                shouldSkipRouteInHistory: true,
                guards: [myPermissionsGuard],
                permissions: [
                    MY_PERMISSIONS.INTERNAL_AUDIT_ACCESS,
                    REGISTERS_PERMISSIONS.AUDIT_REGISTER
                ]
            }
        },
        {
            path: 'discussions',
            name:
                REGISTER_WIZARD_ROUTES.INTERNAL_AUDIT_PERFORMING.DISCUSSIONS
                    .name,
            component: () => import('@/components/registers/Discussions'),
            props: true,
            meta: {
                pageTitle: 'REGISTERS.INTERNAL_AUDITS.TITLE',
                withScaling: true,
                requiresAuth: true,
                register: REGISTER_TYPES.INTERNAL_AUDITS,
                shouldSkipRouteInHistory: true,
                guards: [myPermissionsGuard],
                permissions: [
                    MY_PERMISSIONS.INTERNAL_AUDIT_ACCESS,
                    REGISTERS_PERMISSIONS.AUDIT_REGISTER
                ]
            }
        }
    ]
}
